import { useQuery } from "@tanstack/react-query";
import { getVoucherApi } from "../../services/vouchers/get.voucher.api";

export const useGetVoucherApi = (page: any, size?: any) => {
  const { data, isLoading } = useQuery({
    queryKey: ["vouchers", page],
    queryFn: () => getVoucherApi(page, size),
    enabled: true,
  });
  return {
    vouchers: data,
    isLoading,
  };
};
